import { forwardRef } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../../utils/cn';

export const TooltipProvider = TooltipPrimitive.Provider;
export const TooltipRoot = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = forwardRef(function TooltipContent(
  { className, sideOffset = 6, children, ...props },
  ref,
) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        data-ds-id="ds/overlay/tooltip"
        className={cn(
          'z-50 max-w-xs rounded-ds-md bg-stone-900 px-space-3 py-space-2 text-type-chip text-stone-50 shadow-lg dark:bg-stone-50 dark:text-stone-900 animate-fade-in',
          className,
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow
          className="fill-stone-900 dark:fill-stone-50"
          width={8}
          height={8}
        />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
});
